<div class="tga-card-container">
  <div class="tga-card-header">
    <h1>{{ 'TGA.Advice.Cultivation.SatelliteImages.Title' | translate }}</h1>
    <div class="date-picker-container">
      <mat-form-field class="date-picker-input">
        <mat-date-range-input [rangePicker]="picker" [min]="minDate()" [max]="maxDate()">
          <input hidden matStartDate [ngModel]="startDate()" (dateChange)="onStartDateChange($event)" />
          <input hidden matEndDate [ngModel]="endDate()" (dateChange)="onEndDateChange($event)" />
        </mat-date-range-input>
        <mat-date-range-picker #picker (closed)="onDatePickerClosed()"></mat-date-range-picker>
      </mat-form-field>
      <button mat-icon-button (click)="picker.open()">
        <mat-icon>calendar_today</mat-icon>
      </button>
    </div>
  </div>
  <div class="tga-card-content">
    @if (sortedSatelliteImages$() | async; as satelliteImages) {
      @if (isLoading(satelliteImages)) {
        <div class="loading-container">
          <app-loading-card [loadingText]="'BFP.UI.Loading'" />
        </div>
      } @else if (isError(satelliteImages)) {
        <div class="error-container">
          <p class="error-message">{{ 'TGA.Advice.Cultivation.SatelliteImages.Error' | translate }}</p>
        </div>
      } @else if (isLoaded(satelliteImages)) {
        @if (satelliteImages.state === 'loaded' && satelliteImages.data && satelliteImages.data.length > 0) {
          <!-- Images timeline -->
          <div class="images-timeline-container">
            <div class="timeline-items">
              @for (item of satelliteImages.data; track item.imageDate; let last = $last) {
                <div class="timeline-item">
                  <div
                    class="image-card clickable"
                    [class.active]="last"
                    (click)="onImageClicked(satelliteImages.data, $index)"
                    (keydown)="$event.key === 'Enter' && onImageClicked(satelliteImages.data, $index)"
                  >
                    <img [src]="item | dataUri" [alt]="'Satellite view'" class="satellite-photo" />
                  </div>
                  <div class="timeline-marker" [class.active]="last">
                    <div class="marker-dot"></div>
                  </div>
                  <div class="timeline-date" [class.active]="last">
                    <span class="date-day-month">{{ item.imageDate | date: 'd MMMM' : undefined : locale() }}</span
                    ><br />
                    <span class="date-year">{{ item.imageDate | date: 'yyyy' : undefined : locale() }}</span>
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- Shared legend -->
          <div class="legend-section">
            <div class="legend-box">
              <span class="legend-title">{{ 'TGA.Advice.Cultivation.SatelliteImages.Legend.Title' | translate }}</span>
              <div class="legend-row">
                <span class="legend-label">{{ 'TGA.Advice.Cultivation.SatelliteImages.Legend.Low' | translate }}</span>
                <div class="legend-gradient" [ngStyle]="gradientStyle()"></div>
                <span class="legend-label">{{ 'TGA.Advice.Cultivation.SatelliteImages.Legend.High' | translate }}</span>
              </div>
            </div>
          </div>
        } @else {
          <!-- Empty state -->
          <app-empty-widget [text]="emptyMessage()" />
        }
      }
    }
  </div>
</div>
